/**
 * Created by Jerker Nord on 2023-09-22.
 */
import {Loner} from "../../../Loner";
import {LonerGameAssets} from "../../../LonerGameAssets";
import {gsap, Linear, Power1} from "gsap";
import {TextureHelper} from "../../../utils/TextureHelper";
import {LonerSelectedResultContainer} from "./end/LonerSelectedResultContainer";
import {LonerStartContainer} from "./start/LonerStartContainer";
import {LonerTickTickBoomView} from "./LonerTickTickBoomView";

export class LonerGroundScroller extends PIXI.Container {

    //Texture is 220 wide, but need 2 pixels less to make sure it's overlapping
    private static GROUND_POSITIONS: PIXI.Point[] = [new PIXI.Point(0, 0), new PIXI.Point(218, 0), new PIXI.Point(436, 0), new PIXI.Point(654, 0), new PIXI.Point(872, 0)];

    private _groundTexture: PIXI.Texture;
    private _scrollContainer01: PIXI.Container;
    private _scrollContainer02: PIXI.Container;
    private _endScrollContainer: PIXI.Container;
    private _startScrollContainer: PIXI.Container;
    private _groundTextureWidth: number;
    private _scroll01TL: gsap.core.Timeline;
    private _scroll02TL: gsap.core.Timeline;
    private _startScrollTL: gsap.core.Timeline;
    private _endScrollTL: gsap.core.Timeline;
    private _stopScroll: boolean = false;
    private _resultContainer: LonerSelectedResultContainer;
    private _startContainer: LonerStartContainer;
    private _selection: number;
    private _skipActivated:boolean;

    constructor() {
        super();
        this.init();
    }

    private init(): void {
        this._groundTexture = Loner.assetLoader.getTextures(LonerGameAssets.TTB_GROUND)[0];
        this._groundTextureWidth = this._groundTexture.width;
        this._groundTextureWidth -= 2;

        this._scrollContainer01 = new PIXI.Container();
        this._scrollContainer02 = new PIXI.Container();
        this._endScrollContainer = new PIXI.Container();
        this._startScrollContainer = new PIXI.Container();

        let groundSprite: PIXI.Sprite;
        for (let i: number = 0; i < LonerGroundScroller.GROUND_POSITIONS.length; i++) {
            groundSprite = new PIXI.Sprite(this._groundTexture);
            groundSprite.position = LonerGroundScroller.GROUND_POSITIONS[i];
            this._scrollContainer01.addChild(groundSprite);
        }
        for (let i: number = 0; i < LonerGroundScroller.GROUND_POSITIONS.length; i++) {
            groundSprite = new PIXI.Sprite(this._groundTexture);
            groundSprite.position = LonerGroundScroller.GROUND_POSITIONS[i];
            this._scrollContainer02.addChild(groundSprite);
        }
        for (let i: number = 0; i < LonerGroundScroller.GROUND_POSITIONS.length; i++) {
            groundSprite = new PIXI.Sprite(this._groundTexture);
            groundSprite.position = LonerGroundScroller.GROUND_POSITIONS[i];
            this._scrollContainer02.addChild(groundSprite);
        }

        const startRoadContainer:PIXI.Container = new PIXI.Container();
        for (let i: number = 0; i < LonerGroundScroller.GROUND_POSITIONS.length; i++) {
            groundSprite = new PIXI.Sprite(this._groundTexture);
            groundSprite.position = LonerGroundScroller.GROUND_POSITIONS[i];
            startRoadContainer.addChild(groundSprite);
        }
        startRoadContainer.position.y = 240;
        this._startScrollContainer.addChild(startRoadContainer);

        const endRoadContainer:PIXI.Container = new PIXI.Container();
        for (let i: number = 0; i < LonerGroundScroller.GROUND_POSITIONS.length; i++) {
            groundSprite = new PIXI.Sprite(this._groundTexture);
            groundSprite.position = LonerGroundScroller.GROUND_POSITIONS[i];
            endRoadContainer.addChild(groundSprite);
        }
        endRoadContainer.position.x = -220;
        endRoadContainer.position.y = 240;
        this._endScrollContainer.addChild(endRoadContainer);

        this._scrollContainer01.position.y = 240;
        this._scrollContainer02.position.y = 240;
        this._scrollContainer01.visible = false;
        this.addChild(this._scrollContainer01);
        this._scrollContainer02.visible = false;
        this.addChild(this._scrollContainer02);
        this.addChild(this._endScrollContainer);
        this.addChild(this._startScrollContainer);

        this._endScrollContainer.visible = false;

        this._startContainer = new LonerStartContainer();
        this._startContainer.position.x = 0;
        this._startScrollContainer.addChild(this._startContainer);

        this._resultContainer = new LonerSelectedResultContainer();
        this._resultContainer.position.x = 872;
        this._endScrollContainer.addChild(this._resultContainer);

        this._startScrollTL = gsap.timeline({paused: true, onComplete: () => this.onStartScrollComplete()});
        this._startScrollTL.add(gsap.to(this._startScrollContainer.position, {
            ease: "power1.in",
            duration: 0.6,
            x: 0 - (LonerGroundScroller.GROUND_POSITIONS[1].x / 2)
        }));
        this._startScrollTL.add(gsap.to(this._startScrollContainer.position, {
            ease: "none",
            duration: 0.3,
            x: 0 - LonerGroundScroller.GROUND_POSITIONS[1].x
        }));

        this._scroll01TL = gsap.timeline({paused: true, onComplete: () => this.onScroll01Complete()});
        this._scroll01TL.add(gsap.to(this._scrollContainer01.position, {
            ease: "none",
            duration: 0.6,
            x: 0 - LonerGroundScroller.GROUND_POSITIONS[1].x
        }));

        this._scroll02TL = gsap.timeline({paused: true, onComplete: () => this.onScroll02Complete()});
        this._scroll02TL.add(gsap.to(this._scrollContainer02.position, {
            ease: "none",
            duration: 0.6,
            x: 0 - LonerGroundScroller.GROUND_POSITIONS[1].x
        }));

        this._endScrollTL = gsap.timeline({onComplete: () => this.onEndScrollComplete()});
        this._endScrollTL.add(gsap.to(this._endScrollContainer.position, {
            ease: "none",
            duration: 5.9,
            x: -2200
        }));
        this._endScrollTL.add(gsap.to(this._endScrollContainer.position, {
            duration: 0.7,
            x: -2310
        }));
    }

    public activateSkip():void{
        this._skipActivated = true;
        if (this._scroll01TL.isActive()){
            this._scroll01TL.timeScale(LonerTickTickBoomView.SKIP_TIMESCALE);
        }
        if (this._scroll02TL.isActive()){
            this._scroll02TL.timeScale(LonerTickTickBoomView.SKIP_TIMESCALE);
        }
        if (this._endScrollTL.isActive()){
            this._endScrollTL.timeScale(LonerTickTickBoomView.SKIP_TIMESCALE);
        }
    }

    private onStartScrollComplete(): void {
        this._scrollContainer01.visible = true;
        this._startScrollContainer.visible = false;
        this._startScrollContainer.position = LonerGroundScroller.GROUND_POSITIONS[1];
        this._scroll01TL.restart();
    }

    public startScroll(): void {
        this._startScrollTL.restart();
    }

    public stopScroll(selection: number): void {
        this._selection = selection;
        this._stopScroll = true;
    }

    private doEndScroll(): void {
        this._stopScroll = false;
        this._resultContainer.position.x = 872;
        this._endScrollContainer.position.x = 0;

        this._endScrollContainer.visible = true;
        this._scrollContainer01.visible = false;
        this._scrollContainer02.visible = false;
        this._resultContainer.setOrder(this._selection);
        Loner.tickTickBoomView.doStopCar();
        if (this._skipActivated == true){
            this._endScrollTL.restart().timeScale(LonerTickTickBoomView.SKIP_TIMESCALE);
        }else{
            this._endScrollTL.restart();
        }
    }

    private onScroll01Complete(): void {
        this._scrollContainer01.position.x = 0;
        this._scrollContainer02.visible = true;
        this._scrollContainer01.visible = false;
        if (this._stopScroll == false) {
            this._scroll02TL.restart();
            this._scrollContainer01.visible = false;
            this._scrollContainer01.position.x += this._groundTextureWidth;
        } else {
            this.doEndScroll();
        }
    }

    private onScroll02Complete(): void {
        this._scrollContainer01.position.x = 0;
        this._scrollContainer02.visible = false;
        this._scrollContainer01.visible = true;
        if (this._stopScroll == false) {
            this._scroll01TL.restart();
            this._scrollContainer02.visible = false;
            this._scrollContainer02.position.x += this._groundTextureWidth;
        } else {
            this.doEndScroll();
        }
    }

    private onEndScrollComplete(): void {

    }

    public reset(): void {
        this._skipActivated = false;
        this._scroll01TL.timeScale(1);
        this._scroll02TL.timeScale(1);
        this._endScrollTL.timeScale(1);

        this._resultContainer.position.x = 872;
        this._endScrollContainer.position.x = 0;
        this._endScrollContainer.visible = false;

        this._scrollContainer01.position.x = 0;
        this._scrollContainer02.visible = false;
        this._scrollContainer01.visible = false;

        this._startScrollContainer.visible = true;
        this._startScrollContainer.position.x = 0;
    }

    get resultContainer(): LonerSelectedResultContainer {
        return this._resultContainer;
    }
}